<template>
  <component :is="component" />
</template>

<script lang="ts" setup>
import { useDataConsent } from '../../composables/useDataConsent'

import DidomiCookiesModal from './DidomiCookiesModal.vue'
import OldCookiesModal from './OldCookiesModal.vue'

const { isDidomiEnabled } = useDataConsent()
const component = isDidomiEnabled ? DidomiCookiesModal : OldCookiesModal
</script>
